import React from "react";
import "../style/ButtonsHeader.css";
const ButtonsHeader = () => {
  return (
    <div className="ButtonsHeader">
      <button className="yellowBtn">
        <a
          href="https://www.brainster.io/business"
          target="_blank"
          rel="noopener noreferrer"
        >
          Обуки за компании
        </a>
      </button>
      <button className="blackBtn">
        <a
          href=" https://www.brainster.io/business"
          target="_blank"
          rel="noopener noreferrer"
        >
          Вработи наши студенти
        </a>
      </button>
    </div>
  );
};

export default ButtonsHeader;
